let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("85fC8")).then(() => parcelRequire('eV9zo'));